import { useTranslation } from "shared/localization/localization";
import { Button } from "shared/ui/Button";
import { AlertOrangeIcon } from "shared/ui/Icons";
import { Loader } from "shared/ui/Loader";
import { Portal } from "shared/ui/Portal";
import styles from "./AirCardDeleteModal.module.scss";

type AirCardDeleteModalProps = {
  deleteCardModalHandler: () => void;
  cancelDeletingSavedCard: () => void;
  isSavedCardDeleting: boolean;
};

export const AirCardDeleteModal: RFC<AirCardDeleteModalProps> = ({
  deleteCardModalHandler,
  cancelDeletingSavedCard,
  isSavedCardDeleting,
}) => {
  const { t } = useTranslation();

  return (
    <Portal className={styles.modal} closePopup={cancelDeletingSavedCard}>
      <div className={styles.contentBox}>
        <AlertOrangeIcon className={styles.icon} />
        <p className={styles.title}>
          {t("Delete shipment? It will be deleted from all tags, and this action cannot be undone")}.
        </p>
        <div className={styles.buttons}>
          <Button variant="pale" onClick={cancelDeletingSavedCard} size="small" disabled={isSavedCardDeleting}>
            {t("Cancel")}
          </Button>

          <Button variant="primary" onClick={deleteCardModalHandler} size="small" disabled={isSavedCardDeleting}>
            {isSavedCardDeleting ? t("Deleting") : t("Delete")}
            {isSavedCardDeleting && <Loader size="20px" className={styles.deleteButtonLoader} />}
          </Button>
        </div>
      </div>
    </Portal>
  );
};
